import { log } from "./logger";

const subscriptions: ((event: MessageEvent) => void)[] = [];

const bc = new BroadcastChannel("ng-native");

bc.onmessage = (event) => {
  console.log("Received message from channel", "ng-native", event.data);
  for (const sub of subscriptions) {
    sub(event);
  }
};

export function isNative() {
  if (localStorage.getItem("mockIsNative") === "true") {
    return true;
  }

  return (
    window.IsNative ||
    window.OriginalIsNative ||
    !!window.ReactNativeWebView ||
    navigator.userAgent.includes("ReactNativeWebView")
  );
}

export function subscribe(callback: (event: MessageEvent) => void) {
  console.log("Subscribing to channel", "ng-native", subscriptions, callback);
  subscriptions.push(callback);
}

export function unsubscribe(callback: (event: MessageEvent) => void) {
  const index = subscriptions.indexOf(callback);
  if (index > -1) {
    console.log("Unsubscribing from channel", "ng-native", subscriptions, callback);
    subscriptions.splice(index, 1);
  }
}

export function publish(action: string, params: any, componentInstanceId: string | null) {
  try {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      const payload = { action, params, componentInstanceId, source: "webview" };
      window.ReactNativeWebView.postMessage(JSON.stringify(payload));
    }
  } catch (error) {
    log.error("Native", "Error publishing message to channel", "ng-native", action, params, componentInstanceId, error);
  }
}

export function isMobile() {
  const onMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  return isNative() || (typeof navigator.share === "function" && typeof navigator.canShare === "function" && onMobile);
}

export const native = {
  isNative,
  subscribe,
  unsubscribe,
  publish,
  isMobile,
};
